var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"idle-load",class:{ center: _setup.props.center && !_setup.render }},[(_setup.render)?_vm._t("default"):(_setup.props.spinner)?_c(_setup.BSpinner):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }